(function($) {
  $.extend($, {
	//Assessment CLOSE DIALOG
	occurrenceNewDialog: function (getpathname, buttonPath, helpGuid, callBackValue) {

		var closeDiv = $("<div></div>").appendTo($(document.body));

		var titleTxt;
		var unsavedMsg;
		var selectBtn;
		var closeBtn;

		//returns an array of buttons
		getButtons = function () {
			var dbuttons = {};
			dbuttons[closeBtn] = function () { closeDialog(); };

			dbuttons[selectBtn] = function () { if (newOccurrenceDialog.createOccurrence()) closeDialog(callBackValue); };

			return dbuttons;
		}

		//function to display the returned data
		setdata = function (data) {
			origData = data;
			closeDiv.html(data);
		}

		//close the sucker down
		closeDialog = function () {
		    closeDiv.dialog("close").dialog("destroy");
			closeDiv.remove();
		}

		//call the controller for the data
		$.get(getpathname, {}, function (data) {
			setdata(data);
		});

		//here is the actual processing
		//gets the button txts
		$.ajax({ type: "GET",
			url: buttonPath,
			dataType: "json",
			async: false,
			success: function (data) {
				selectBtn = data.create;
				closeBtn = data.cancel;
				titleTxt = data.title;
				unsavedMsg = data.unsavedMsg;
			}
		});

		//open the dialog
		closeDiv.dialog({
			autoOpen: false,
			title: titleTxt,
			closeOnEscape: false,
			close: function () { $(this).dialog('destroy').remove(); },
			open: function () { },
			width: 540,
			buttons: getButtons(),
			resizable: false,
			modal: true,
			position: ['centre', 150]
		});
		closeDiv.dialog("open");
		closeDiv.AddHelpContext(helpGuid, '{5D20D196-1753-490F-BB1D-11ED6B92787C}');

	},

	//Assessment CLOSE DIALOG
	assessmentCloseDialog: function (getpathname, buttonPath, helpGuid, parentHelpGuid, callBackValue) {

		var closeDiv = $("<div></div>").appendTo($(document.body));

		var titleTxt;
		var unsavedMsg;
		var selectBtn;
		var closeBtn;

		//returns an array of buttons
		getButtons = function () {
			var dbuttons = {};
			dbuttons[closeBtn] = function () { closeCloseAssassmentDialog(); };
			dbuttons[selectBtn] = function () { submitCloseAssessmentDialog(callBackValue); };

			return dbuttons;
		}

		//function to display the returned data
		setdata = function (data) {
			origData = data;
			closeDiv.html(data);
		}

		//close the sucker down
		closeCloseAssassmentDialog = function () {
		    closeDiv.dialog("close").dialog("destroy");
			closeDiv.remove();
		}

		//call the controller for the data
		$.get(getpathname, {}, function (data) {
			setdata(data);
		});

		//here is the actual processing
		//gets the button txts
		$.ajax({ type: "GET",
			url: buttonPath,
			dataType: "json",
			async: false,
			success: function (data) {
				selectBtn = data.submit;
				closeBtn = data.cancel;
				titleTxt = data.title;
				unsavedMsg = data.unsavedMsg;
			}
		});

		//open the dialog
		closeDiv.dialog({
			autoOpen: false,
			title: titleTxt,
			closeOnEscape: false,
			close: function () { $(this).dialog('destroy').remove(); },
			open: function () { },
			width: 400,
			buttons: getButtons(),
			resizable: false,
			modal: true,
			maxHeight: 350,
			position: ['centre', 150]
		});
		closeDiv.dialog("open");
		closeDiv.AddHelpContext(helpGuid, parentHelpGuid);

	},
	//Assessment CLOSE DIALOG
	investigationCloseDialog: function (getpathname, buttonPath, helpGuid, parentHelpGuid, callBackValue) {

		var closeDiv = $("<div></div>").appendTo($(document.body));

		var titleTxt;
		var unsavedMsg;
		var selectBtn;
		var closeBtn;

		//returns an array of buttons
		getButtons = function () {
			var dbuttons = {};
			dbuttons[closeBtn] = function () { closeCloseInvestigationDialog(); };
			dbuttons[selectBtn] = function () { submitCloseInvestigationDialog(callBackValue); };

			return dbuttons;
		}

		//function to display the returned data
		setdata = function (data) {
			origData = data;
			closeDiv.html(data);
		}

		//close the sucker down
		closeCloseInvestigationDialog = function () {
		    closeDiv.dialog("close").dialog("destroy");
			closeDiv.remove();
		}

		//call the controller for the data
		$.get(getpathname, {}, function (data) {
			if (data.Successful === false) {
				closeDiv.dialog("close");
				return;
			}
			setdata(data);
		});

		//here is the actual processing
		//gets the button txts
		$.ajax({ type: "GET",
			url: buttonPath,
			dataType: "json",
			async: false,
			success: function (data) {
				selectBtn = data.submit;
				closeBtn = data.cancel;
				titleTxt = data.title;
				unsavedMsg = data.unsavedMsg;
			}
		});

		//open the dialog
		closeDiv.dialog({
			autoOpen: false,
			title: titleTxt,
			closeOnEscape: false,
			close: function () { $(this).dialog('destroy').remove(); },
			open: function () { },
			width: 400,
			buttons: getButtons(),
			resizable: false,
			modal: true,
			maxHeight: 350,
			position: ['centre', 150]
		});
		closeDiv.dialog("open");
		closeDiv.AddHelpContext(helpGuid, parentHelpGuid);

	},

	//Assessment GENERIC DIALOG
	assessmentDialog: function (getpathname, buttonPath, helpGuid, parentHelp, callBackValue, requiredWidth) {

		var assessmentDiv = $("<div id='genericAssessmentDialog'></div>").appendTo($(document.body));

		var titleTxt;
		var unsavedMsg;
		var selectBtn;
		var closeBtn;
		var vwidth = 500;

		if (requiredWidth != undefined && requiredWidth != null) {
			vwidth = requiredWidth;
		}

		//returns an array of buttons
		getButtons = function () {
			var dbuttons = {};
			dbuttons[closeBtn] = function () { $.genericAssessmentCloseDialog(this, assessmentDiv); };
			if (selectBtn.length > 0) {
				dbuttons[selectBtn] = function () { submitAssessmentDialog(callBackValue, this, assessmentDiv); };
			}
			return dbuttons;
		};

		//function to display the returned data
		setdata = function (data) {
			origData = data;
			assessmentDiv.html(data);
		};

		//call the controller for the data
		$.get(getpathname, {}, function (data) {
			setdata(data);
		});

		//here is the actual processing
		//gets the button txts
		$.ajax({ type: "GET",
			url: buttonPath,
			dataType: "json",
			async: false,
			success: function (data) {
				selectBtn = data.submit;
				closeBtn = data.cancel;
				titleTxt = data.title;
				unsavedMsg = data.unsavedMsg;
				if (data.dialogWidth != null) { vwidth = parseInt(data.dialogWidth); }
			}
		});

		//open the dialog
		assessmentDiv.dialog({
			autoOpen: false,
			title: titleTxt,
			closeOnEscape: false,
			close: function () { $(this).dialog('destroy').remove(); },
			open: function () { },
			width: vwidth,
			buttons: getButtons(),
			resizable: false,
			modal: true,
			maxHeight: 350,
			position: ['centre', 150]
		});
		assessmentDiv.dialog("open");
		assessmentDiv.AddHelpContext(helpGuid, parentHelp);

	},
    //GENERIC CLOSE FUNCTION
	genericSafetyCloseDialog: function (obj, divToGo) {
	    var theObj = obj;
	    var theDiv = divToGo;

	    doClose = function () {
	        $(theObj).dialog("close");
	        $(theObj).dialog("destroy");
	        theDiv.remove();
	    }

	    if (getBlockMessage() != undefined && getBlockMessage().length > 0) {
	        $.confirmDialog(getBlockMessage(), "Safety Management", function () { $.ClearNavigationWarning(); doClose(); });
	    }
	    else {
	        doClose();
	    }
	},

//Assessment GENERIC DIALOG
assessmentReasonDialog: function (getpathname, buttonPath, helpGuid, parentHelp, callBackValue, requiredWidth) {

  var assessmentDiv = $("<div id='genericAssessmentDialog'></div>").appendTo($(document.body));

  var titleTxt;
  var unsavedMsg;
  var selectBtn;
  var closeBtn;
  var vwidth = 430;

  if (requiredWidth != undefined && requiredWidth != null) {
    vwidth = requiredWidth;
  }

  //returns an array of buttons
  getButtons = function () {
    var dbuttons = {};
    dbuttons[closeBtn] = function () { $.genericAssessmentCloseDialog(this, assessmentDiv); };
    if (selectBtn.length > 0) {
      dbuttons[selectBtn] = function () { submitAssessmentDialog(callBackValue, this, assessmentDiv); };
    }
    return dbuttons;
  };

  //function to display the returned data
  setdata = function (data) {
    origData = data;
    assessmentDiv.html(data);
  };

  //call the controller for the data
  $.get(getpathname, {}, function (data) {
    setdata(data);
  });

  //here is the actual processing
  //gets the button txts
  $.ajax({ type: "GET",
    url: buttonPath,
    dataType: "json",
    async: false,
    success: function (data) {
      selectBtn = data.submit;
      closeBtn = data.cancel;
      titleTxt = data.title;
      unsavedMsg = data.unsavedMsg;
      if (data.dialogWidth != null) { vwidth = parseInt(data.dialogWidth); }
    }
  });

  //open the dialog
  assessmentDiv.dialog({
    autoOpen: false,
    title: titleTxt,
    closeOnEscape: false,
    close: function () { $(this).dialog('destroy').remove(); },
    open: function () { },
    width: vwidth,
    buttons: getButtons(),
    resizable: false,
    modal: true,
    maxHeight: 350,
    position: ['centre', 150]
  });
  assessmentDiv.dialog("open");
  assessmentDiv.AddHelpContext(helpGuid, parentHelp);

},

	//GENERIC CLOSE FUNCTION
	genericAssessmentCloseDialog: function (obj, divToGo) {
		var theObj = obj;
		var theDiv = divToGo;

		doClose = function () {
			$(theObj).dialog("close");
			$(theObj).dialog("destroy");
			$(theDiv).remove();
		}
	   
		//if (getBlockMessage() != undefined && getBlockMessage().length > 0) {
		//	$.confirmDialog(getBlockMessage(), "Safety Management", function () { $.ClearNavigationWarning(); doClose(); });
		//}
		//else {
			doClose();
	//	}
	}
	 ,
	//INVESTIGATION LINK DIALOG
	investigationLinkDialog: function (occId, title, select, cancel) {
		var investigationLinkDiv = $("<div></div>");
		var pathname = $.currentSitePath;
		//		if (linkSource == undefined) {
		pathname = pathname + "Safety.aspx/Assessment/LinkToExistingInvestigation?occId=" + occId;
		//		}
		//		else {
		//			pathname = pathname + "Safety.aspx/" + linkSource + "/LinkToExistingInvestigation";
		//		}
		var setpathname = $.currentSitePath + "Safety.aspx/Assessment/InvestigationLinkSave";

		//call the controller for the data
		$.get(pathname, {}, function (data) {
			investigationLinkDiv.html(data);
		});

		getLinkButtons = function () {
			var lbuttons = {};
			lbuttons[cancel] = function () { $.genericAssessmentCloseDialog(this, investigationLinkDiv); };
			lbuttons[select] = function () { saveInvestigationLink(this, investigationLinkDiv); };
			return lbuttons;
		}

		closeInvestigationLink = function (obj, div) {
			$(document).unbind("SelectInvestigationLink");
			$(document).unbind("InvestigationLinkChange");
			$(document).unbind("investigationSearch");
			$(obj).dialog("close");
			$(obj).dialog("destroy");
			div.remove();
		}

		//		saveInvestigationLink = function () {
		//			//saves the link
		//			$(document).trigger("SelectInvestigationLink");
		//		}

		//open the dialog
		investigationLinkDiv.dialog({
			autoOpen: false,
			title: title,
			closeOnEscape: false,
			width: 950,
			minWidth: 530,
			maxWidth: 950,
			buttons: getLinkButtons(),
			resizable: false,
			modal: true,
			maxHeight: 450,
			position: ['centre', 85]
		});
	investigationLinkDiv.AddHelpContext('{7D984386-9B31-4AB6-BA2C-1A011CC1C64F}', '{896D6948-C0AB-4346-8F44-5C494AF0F326}');
		investigationLinkDiv.dialog("open");
	},
	//OCCURRENCE LINK DIALOG
	occurrenceLinkDialog: function (wrId, title, cancel, select) {
		var occurrenceLinkDiv = $("<div></div>");
		var pathname = $.currentSitePath;
		//		if (linkSource == undefined) {
		pathname = pathname + "Safety.aspx/Investigation/LinkToExistingOccurrence?wrId=" + wrId;
		//		}
		//		else {
		//			pathname = pathname + "Safety.aspx/" + linkSource + "/LinkToExistingInvestigation";
		//		}
		var setpathname = $.currentSitePath + "Safety.aspx/Assessment/InvestigationLinkSave";

		//call the controller for the data
		$.get(pathname, {}, function (data) {
			occurrenceLinkDiv.html(data);
		});

		getLinkButtons = function () {
			var lbuttons = {};
			lbuttons[cancel] = function () { closeOccurrenceLink(); };
			lbuttons[select] = function () { saveInvestigationLink(); };


			return lbuttons;
		}

		closeOccurrenceLink = function () {
			$(document).unbind("SelectOccurrenceLink");
			$(document).unbind("OccurrenceLinkChange");
			$(document).unbind("occurrenceSearch");
			$(this).dialog("close");
			$(this).dialog("destroy");
			occurrenceLinkDiv.remove();
		}

		//		saveInvestigationLink = function () {
		//			//saves the link
		//			$(document).trigger("SelectInvestigationLink");
		//		}

		//open the dialog
		occurrenceLinkDiv.dialog({
			autoOpen: false,
			title: title,
			closeOnEscape: false,
			width: 780,
			minWidth: 530,
			maxWidth: 780,
			buttons: getLinkButtons(),
			resizable: false,
			modal: true,
			maxHeight: 350,
			position: ['centre', 85]
		});
	occurrenceLinkDiv.AddHelpContext('{BDCB2865-719D-4384-8093-3EC4FB8FFDFC}', '{e3a5886c-1d15-4353-8e6c-c3e159ac5146}');
		occurrenceLinkDiv.dialog("open");
	},
	//ASSESSMENT BASIC VIEW DIALOG           
	assessmentBasicViewDialog: function (getpathname, buttonPath, helpGuid, parentHelp, callBackValue) {
		var assessmentDiv = $("<div id='genericAssessmentDialog'></div>").appendTo($(document.body));
		var titleTxt;
		var unsavedMsg;
		var selectBtn;
		var closeBtn;
    var saving = false;
		//	var auditId = assessmentData[0];
	    //returns an array of buttons
    var onCallback = callBackValue;
	    
		getButtons = function () {
			var dbuttons = {};
			dbuttons[closeBtn] = function () { closeDialog(); };
			dbuttons[selectBtn] = function () { $.showLoadingSpinner(); saveAssessment(function () { $.hideLoadingSpinner(); closeDialog(); onCallback.apply(this, arguments); }); };

			return dbuttons;
		}

		//function to display the returned data
		setdata = function (data) {
			origData = data;
			assessmentDiv.html(data);
		}

		//close the sucker down
		closeDialog = function () {
		    assessmentDiv.dialog("close").dialog("destroy");
		    
		    
			assessmentDiv.remove();
			$.hideLoadingSpinner();
		}

		//call the controller for the data
		$.get(getpathname, {}, function (data) {
			setdata(data);
		});

		//here is the actual processing
		//gets the button txts
		$.ajax({ type: "GET",
			url: buttonPath,
			dataType: "json",
			async: false,
			success: function (data) {
				selectBtn = data.create;
				closeBtn = data.cancel;
				titleTxt = data.title;
				unsavedMsg = data.unsavedMsg;
				if (data.dialogWidth != null) { }
			}
		});

		//open the dialog
		assessmentDiv.dialog({
			autoOpen: false,
			title: titleTxt,
			closeOnEscape: false,
			close: function () { },
			open: function () { },
			width: 700,
			buttons: getButtons(),
			resizable: false,
			//modal: true,
			stack: false,
			maxHeight: 480,
			position: ['centre', 150]
		});
		assessmentDiv.dialog("open");

		assessmentDiv.AddHelpContext(helpGuid, parentHelp);

	},
	annex13Dialog: function (getpathname, buttonPath, helpGuid, parentHelp, callBackValue) {
	    var assessmentDiv = $("<div id='genericAssessmentDialog'></div>").appendTo($(document.body));
	    var titleTxt;
	    var unsavedMsg;
	    var selectBtn;
	    var closeBtn;
	    var saving = false;
	    //	var auditId = assessmentData[0];
	    //returns an array of buttons
	    var onCallback = callBackValue;

	    getButtons = function () {
	        var dbuttons = {};
	        dbuttons[closeBtn] = function () { closeDialog(); };
	        dbuttons[selectBtn] = function () { $.showLoadingSpinner(); saveAnnex(function () { $.hideLoadingSpinner(); closeDialog(); onCallback.apply(this, arguments); }); };

	        return dbuttons;
	    }

	    //function to display the returned data
	    setdata = function (data) {
	        origData = data;
	        assessmentDiv.html(data);
	    }

	    //close the sucker down
	    closeDialog = function () {
	        assessmentDiv.dialog("close").dialog("destroy");


	        assessmentDiv.remove();
	        $.hideLoadingSpinner();
	    }

	    //call the controller for the data
	    $.get(getpathname, {}, function (data) {
	        setdata(data);
	    });

	    //here is the actual processing
	    //gets the button txts
	    $.ajax({
	        type: "GET",
	        url: buttonPath,
	        dataType: "json",
	        async: false,
	        success: function (data) {
	            selectBtn = data.submit;
	            closeBtn = data.cancel;
	            titleTxt = data.title;
	            unsavedMsg = data.unsavedMsg;
	            if (data.dialogWidth != null) { }
	        }
	    });

	    //open the dialog
	    assessmentDiv.dialog({
	        autoOpen: false,
	        title: titleTxt,
	        closeOnEscape: false,
	        close: function () { },
	        open: function () { },
	        width: 700,
	        buttons: getButtons(),
	        resizable: false,
	        //modal: true,
	        stack: false,
	        maxHeight: 480,
	        position: ['centre', 150]
	    });
	    assessmentDiv.dialog("open");

	    assessmentDiv.AddHelpContext(helpGuid, parentHelp);

	}
})
})
(jQuery);